import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SysDialog,{attrs:{"largura":1000,"ocultar-acoes":"","titulo":"Mais Detalhes do Produto"},scopedSlots:_vm._u([{key:"ativador",fn:function(){return [_c(VBtn,{attrs:{"icon":"","x-small":""},on:{"click":function($event){_setup.dialog_ativo = ! _setup.dialog_ativo}}},[_c(VIcon,{attrs:{"size":16}},[_vm._v("mdi-information-outline")])],1)]},proxy:true}]),model:{value:(_setup.dialog_ativo),callback:function ($$v) {_setup.dialog_ativo=$$v},expression:"dialog_ativo"}},[_c(_setup.CaracteristicasProduto,{attrs:{"produto":{
      id_grupo: _setup.props.id_grupo,
      id_filial: 9999,
      id_produto: _setup.props.idproduto
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }